import React from 'react';

import { processTextWithLinks } from '../../utilities/processTextWithLinks';
import styles from './datetime-picker.module.css';

/**
 * DatetimePicker component displays a datetime picker input with a label.
 *
 * @param {Object} props - The component props
 * @param {string} props.id - The input id
 * @param {string} props.name - The input name
 * @param {boolean} props.required - Whether the input is required
 * @param {string} props.labelText - The label text
 * @param {string} props.dateTimeHeading - The date time heading
 * @param {string} props.type - The type of the input (date or time)
 * @param {function} props.onChange - Callback when date value changes
 * @param {string} props.defaultValue - Default date value (YYYY-MM-DD format)
 * @returns {import('react').JSX.Element} The rendered component
 */
export const DatetimePicker = ({ id, name, required = false, labelText, dateTimeHeading, type, onChange, defaultValue }) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className={styles['datetime-picker'] + ' field'}>
      <label className={'field__label'} htmlFor={id}>
        {processTextWithLinks(labelText)}
      </label>
      <input
        className={styles['datetime-picker__input'] + ' field__input'}
        id={id}
        name={name}
        type={type}
        required={required}
        onChange={handleChange}
        defaultValue={defaultValue}
        min="1920-01-01"
      />
      <div className={styles['datetime-picker__label']}>
        <p className={'body-xs'}>{processTextWithLinks(dateTimeHeading)}</p>
      </div>
    </div>
  );
};
